//include 8
jQuery(function(){

    var setupInitiallyDisabledElements = function (selectors, enableOrDisable, clickCallback) {
        for (var i in selectors) {
            var selector = selectors[i];
            $(`[data-to-disable='${selector}']`).each(function () {
                var element = $(this);
                if(element.is(":disabled")){
                    if(!!element.is("[data-activate-on-click]")){
                        if(!!clickCallback){
                            var overlay = $('<div class="pp-click-overlay"></div>'); 
                            overlay.css({
                                'position':'absolute',
                                'top':0,
                                'left':0,
                                'right':0,
                                'bottom':0,
                                'z-index':999
                            });
                            element.parent().append(overlay);
                            overlay.on("click.disabler", function(e){
                                clickCallback();
                                setTimeout(function(){
                                    element.click();
                                },50);
                            });
                        }
                    }
                }
            });
        }
    }

    var enableOrDisableElements = function (selectors, enableOrDisable, clickCallback) {//true - enable, false - disable
        for (var i in selectors) {
            var selector = selectors[i];
            $(`[data-to-disable='${selector}']`).each(function () {
                var element = $(this);
                element.off("click.disabler");
                element.parent().find(".pp-click-overlay").remove();
                if (!!enableOrDisable) {
                    //if (element.hasClass("select2-hidden-accessible")) {
                    //    element.select2("enable");
                    //}
                    //else {
                        var formFunctions = element.data("form-element-functions");
                        if(!!formFunctions && !!formFunctions.enable)
                            formFunctions.enable();
                        else
                            element.prop("disabled", false);
                    //}
                    element.closest("[data-add-disabled-class]").removeClass("disabled");
                }
                else {
                    //if (element.hasClass("select2-hidden-accessible")) {
                    //    element.select2("disable");
                    //}
                    //else {
                        var formFunctions = element.data("form-element-functions");
                        if(!!formFunctions && !!formFunctions.disable){
                            formFunctions.disable();
                            if(!!element.is("[data-clear-on-disable]")){
                                if(!!formFunctions.clear){
                                    formFunctions.clear();
                                }
                            }                            
                            if(!!element.is("[data-activate-on-click]")){
                                if(!!clickCallback){
                                    var overlay = $('<div class="pp-click-overlay"></div>'); 
                                    overlay.css({
                                        'position':'absolute',
                                        'top':0,
                                        'left':0,
                                        'right':0,
                                        'bottom':0,
                                        'z-index':999
                                    });
                                    element.parent().append(overlay);
                                    overlay.on("click.disabler", function(e){
                                        clickCallback();
                                        setTimeout(function(){
                                            element.click();
                                        },50);
                                    });
                                }
                            }
                        }
                        else{
                            element.prop("disabled", true);
                            if(!!element.is("[data-clear-on-disable]")){
                                element.val("");
                            }
                            if(!!element.is("[data-activate-on-click]")){
                                if(!!clickCallback){
                                    var overlay = $('<div class="pp-click-overlay"></div>');
                                    overlay.css({
                                        'position':'absolute',
                                        'top':0,
                                        'left':0,
                                        'right':0,
                                        'bottom':0,
                                        'z-index':999
                                    });
                                    element.parent().append(overlay);
                                    overlay.on("click.disabler", function(e){
                                        clickCallback();
                                        setTimeout(function(){
                                            element.click();
                                        },50);
                                    });
                                }
                            }
                        }
                    //}
                    element.closest("[data-add-disabled-class]").addClass("disabled");
                }
            });

            if (!!enableOrDisable) {
                window.pixelpoint.pubSub.publish(`on:disabler:${selector}:enable`, []);
            }
            else {
                window.pixelpoint.pubSub.publish(`on:disabler:${selector}:disable`, []);
            }
        }
    }

    window.pixelpoint.ppComponents.disabler = function($this){
        //var $this = $(this);
        var elementsToDisable = $this.data("disabler");
        var disableOnValue = $this.is("[data-disable-on-value]");
        if (!elementsToDisable)
            return;
        var toDisableArray = elementsToDisable.split(",");

        if ($this.is("[type='checkbox']") || $this.is("[type='radio']")) {
            setupInitiallyDisabledElements(toDisableArray, disableOnValue, function(){
                            if($this.is(":checked"))
                                $this.prop('checked', false).trigger("change");
                        });
        }

        $this.on("change", function () {
            if ($this.is("[type='checkbox']") || $this.is("[type='radio']")) {
                if ($this.is(":checked")) {
                    enableOrDisableElements(toDisableArray, disableOnValue, function(){
                        if($this.is(":checked"))
                            $this.prop('checked', false).trigger("change");
                    });
                }
                else {
                    enableOrDisableElements(toDisableArray, !disableOnValue, function(){
                        if($this.is(":checked"))
                            $this.prop('checked', false).trigger("change");
                    });
                }
            }
            else {
                var value = $this.val();
                if (!value) {
                    enableOrDisableElements(toDisableArray, !disableOnValue);
                }
                else {
                    enableOrDisableElements(toDisableArray, disableOnValue);
                }
            }
        });
    }

    $("[data-disabler]").each(function () {
        window.pixelpoint.ppComponents.disabler($(this));
    });

});